/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Phone_NumberInputs */

const en_admin_external_booking_edit_phone_number = /** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number`)
};

const de_admin_external_booking_edit_phone_number = /** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer`)
};

const es_admin_external_booking_edit_phone_number = /** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de teléfono`)
};

const fr_admin_external_booking_edit_phone_number = /** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de téléphone`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */
const it_admin_external_booking_edit_phone_number = en_admin_external_booking_edit_phone_number;

/** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_phone_number = en_admin_external_booking_edit_phone_number;

/** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */
const pl_admin_external_booking_edit_phone_number = en_admin_external_booking_edit_phone_number;

/** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */
const hu_admin_external_booking_edit_phone_number = en_admin_external_booking_edit_phone_number;

/** @type {(inputs: Admin_External_Booking_Edit_Phone_NumberInputs) => LocalizedString} */
const ro_admin_external_booking_edit_phone_number = en_admin_external_booking_edit_phone_number;

/**
* | output |
* | --- |
* | "Phone number" |
*
* @param {Admin_External_Booking_Edit_Phone_NumberInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_phone_number = /** @type {((inputs?: Admin_External_Booking_Edit_Phone_NumberInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Phone_NumberInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_phone_number(inputs)
	if (locale === "de") return de_admin_external_booking_edit_phone_number(inputs)
	if (locale === "es") return es_admin_external_booking_edit_phone_number(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_phone_number(inputs)
	if (locale === "it") return it_admin_external_booking_edit_phone_number(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_phone_number(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_phone_number(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_phone_number(inputs)
	return ro_admin_external_booking_edit_phone_number(inputs)
});
export { admin_external_booking_edit_phone_number as "admin.external_booking_edit.phone_number" }